module.exports = __webpack_public_path__ + "static/media/felizAnoNovo.2b7c108e.png";